export default "__VITE_ASSET__zvzTCzjj__"